<script>
  import FeatureListSection from '../EditorV2Pages/FeatureListSection.svelte';
  import { useEditorV2Setup } from '../EditorV2Pages/setup.js';
  useEditorV2Setup();
</script>

<FeatureListSection />